export const CLOUD_ENV = '/vulnerabilities/cloud-env/';
export const DATASTORE_DETAILS = '/datastore-details/';
export const POLICY_SETTINGS = '/settings/policy-settings/';
export const POLICY_DETAILS = '/policy-details/';
export const DATASTORE = '/datastore';
